import * as Y from 'yjs'
import { TiptapTransformer } from '@hocuspocus/transformer'
import { yXmlFragmentToProseMirrorRootNode } from 'y-prosemirror'
import { yjsInstance } from '@learnics/models/src/utils/yjsInstance.mjs'

yjsInstance.set(Y, TiptapTransformer, yXmlFragmentToProseMirrorRootNode)
